export const formatCpf = (cpf?: string) => {
  if (!cpf) return "";
  const numbersOnly = cpf.replace(/\D/g, "");
  return numbersOnly
    .replace(/^(\d{3})(\d)/, "$1.$2")
    .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
    .replace(/\.(\d{3})(\d)/, ".$1-$2");
};
